// import { SeparadorPeB } from "../../../../shared/assets/logos";

export const DivisorPeB = () => {
    return (
        <div
            className="divisor-peb"
            style={{
                display: "flex",
                width: "100%",
                height: "4px",
            }}
        >
            <div style={{ flex: 1, backgroundColor: "gray" }} />
            {/* <img src={SeparadorPeB} width="100%" alt="separador" /> */}
            <br />
        </div>
    );
};
